import ReactModal from "react-modal";
import React, {useContext, useEffect, useState} from "react";
import {useAddToHomescreenPrompt} from "@hooks/useAddToHomescreenPrompt";
import {isIOS, isMobile, isMobileSafari} from "react-device-detect";
import { SettingsContext } from '../contexts/index.jsx';

const InstallationDescription = () => {

    if (isMobileSafari) {
        return (<>
            <p>
                Tap "<img src='/assets/icons/Fichier 2.png'/>" button and click "Add to Home Screen"
            </p>
        </>)
    } else if (isIOS) {
        return (<>
            <p>
                Step 1: Copy URL
            </p>
            <p>
                Step 2: Open Safari
            </p>
            <p>
                Step 3: Tap "<img src='/assets/icons/Fichier 2.png'/>" button
            </p>
            <p>
                Step 4: Click “Add to Home Screen”
            </p>
        </>)
    } else return (<button onClick={() => window.a2hsInstall.prompt()}>Install</button>)
}
const A2SHPopup = ({isNewAccount}) => {
    const { settings } = useContext(SettingsContext);
    const [isVisible, setVisibleState] = useState(false);
    const [prompt, promptToInstall] = useAddToHomescreenPrompt();

    const hide = () => setVisibleState(false);
    useEffect(
        () => {
            setVisibleState(true)
        },
        [prompt]
    );
    return (
        <ReactModal
            {...{
                isOpen: isMobile && isNewAccount && isVisible,
                onRequestClose: hide,
            }}
        >
            <div className={'a2hs-main-block'}>
                <div className="close-modal">
                    <img src="/assets/icons/cancel-black.svg" onClick={hide}/>
                </div>
                <div className={'a2hs-content-block'}>
                    {settings?.homescreen && <img src={`/api/logos/${settings.homescreen}`} />}
                    <h1>ADD TO HOME SCREEN</h1>
                    <span> Add {settings.name} to your home screen to access all features like an app.</span>
                    <InstallationDescription/>
                </div>

            </div>
        </ReactModal>
    )
}
export default A2SHPopup
